/**
 * Block: two-column-image-text-general
 * V2 JS — Swiper slider for multi-slide sections + video modal triggers
 */

export function init() {
  const sliderEl = document.querySelector('.start-slide');
  if (!sliderEl) return;

  function initSwiper() {
    if (typeof Swiper === 'undefined') {
      // Swiper CDN not loaded yet — retry
      setTimeout(initSwiper, 100);
      return;
    }

    new Swiper('.start-slide', {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 10000,
      },
      pagination: {
        el: '.two-column-image-text-general__dots',
        clickable: true,
      },
    });
  }

  initSwiper();

  // Video modal triggers
  const triggerElements = document.querySelectorAll('.video-iframe-trigger');

  triggerElements.forEach((item) => {
    const target = item.dataset.target;
    const targetURLPath = item.dataset.targeturlpath;
    const iframeWrapper = item
      .closest('.two-column-image-text-general')
      ?.querySelector('.two-column-image-text-general__iframe-wrapper');

    if (!iframeWrapper) return;

    if (target) {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        iframeWrapper.classList.add('iframe-visible');
        const iframe = iframeWrapper.querySelector('iframe');
        if (iframe) {
          iframe.setAttribute(
            'src',
            `https://www.youtube-nocookie.com/embed/${target}?autoplay=1`
          );
        }
      });
    }

    if (targetURLPath) {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        iframeWrapper.classList.add('iframe-visible');
        const video = iframeWrapper.querySelector('video');
        if (video) {
          video.setAttribute('src', targetURLPath);
          video.load();
          video.play();
        }
      });
    }

    iframeWrapper.addEventListener('click', () => {
      iframeWrapper.classList.remove('iframe-visible');
      const iframe = iframeWrapper.querySelector('iframe');
      if (iframe) iframe.setAttribute('src', '');
      const video = iframeWrapper.querySelector('video');
      if (video) video.setAttribute('src', '');
    });
  });
}
